import { render, staticRenderFns } from "./UserFormCard.vue?vue&type=template&id=77f21e6e&scoped=true&"
import script from "./UserFormCard.vue?vue&type=script&lang=js&"
export * from "./UserFormCard.vue?vue&type=script&lang=js&"
import style0 from "./UserFormCard.vue?vue&type=style&index=0&id=77f21e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f21e6e",
  null
  
)

export default component.exports